import type { SxProps, Theme } from '@mui/material/styles';

type AccountDetailStyleMap = {
    loadingContainer: SxProps<Theme>
    notFoundContainer: SxProps<Theme>
    root: SxProps<Theme>
    header: SxProps<Theme>
    headerLeft: SxProps<Theme>
    headerActions: SxProps<Theme>
    mainColumn: SxProps<Theme>
    card: SxProps<Theme>
    cardHeader: SxProps<Theme>
    infoRow: SxProps<Theme>
    infoLabel: SxProps<Theme>
    statusContent: SxProps<Theme>
    statusRow: SxProps<Theme>
    statusMeta: SxProps<Theme>
    statusMetaRow: SxProps<Theme>
};

export const accountDetailStyles: AccountDetailStyleMap = {
    loadingContainer: { display: 'flex', justifyContent: 'center', alignItems: 'center', py: 10 },
    notFoundContainer: { display: 'flex', flexDirection: 'column', alignItems: 'center', py: 10, gap: 2 },
    root: { display: 'flex', flexDirection: 'column', gap: 3 },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 },
    headerLeft: { display: 'flex', alignItems: 'center', gap: 2 },
    headerActions: { display: 'flex', gap: 1.5 },
    mainColumn: { display: 'flex', flexDirection: 'column', gap: 3 },
    card: { border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden' },
    cardHeader: { px: 3, py: 2, borderBottom: '1px solid', borderColor: 'divider' },
    infoRow: { px: 3, py: 2, display: 'grid', gridTemplateColumns: '160px 1fr', gap: 2, alignItems: 'center' },
    infoLabel: { display: 'flex', alignItems: 'center', gap: 0.5 },
    statusContent: { px: 3, py: 3 },
    statusRow: { display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 },
    statusMeta: { display: 'flex', flexDirection: 'column', gap: 1.5 },
    statusMetaRow: { display: 'flex', justifyContent: 'space-between' },
};

export const getAccountStatusDotStyles = (disabled?: boolean, pending?: boolean): SxProps<Theme> => ({
    width: 12,
    height: 12,
    borderRadius: '50%',
    bgcolor: disabled ? 'error.main' : pending ? 'warning.main' : 'success.main',
});
